import { useDataChange, useDataOriginalValue } from 'Simple/Data'
import isEqual from 'lodash/isEqual.js'

/** @type {import('Simple/types.js').useDataOnChange} */
export default function useDataOnChange(props, data) {
  let change = useDataChange({
    context: 'tab',
    path: 'selected.has_changes',
    viewPath: props.viewPath,
  })

  let originalValue = useDataOriginalValue({
    context: 'board',
    viewPath: props.viewPath,
  })
  return async function onChange(value) {
    if (!isEqual(originalValue, value) || !originalValue) {
      change(true)
    }
  }
}
